import { Module, Mutation, Action, VuexModule } from 'vuex-module-decorators'
import Axios from 'axios'
import { ICartNL, ICartBE } from 'helpers/types'
import { BASE_URL } from '../../helpers/constants'

const CART_DATA_KEY_NL = 'cartDataKeyNLV2'
const CART_DATA_KEY_BE = 'cartDataKeyBE'

@Module({ namespaced: true })
export default class CartModule extends VuexModule {
  public cartData: ICartNL = {
    ProjectInformation:{
      Organization: '',
      ProjectName: '',
      ContactPersonName: '',
      PhoneNumber: '',
      EmailAddress: ''
    },
    QuotationRequestData: {
      Name: '',
      EmailAddress: '',
      PersonalContact: false
    },
    Attachments: []
  }

  public cartDataBe: ICartBE = {
    ProjectInformation: {
      ProjectName: '',
      ProjectInfo: '',
      ContactPersonName: '',
      PhoneNumber: '',
      EmailAddress: ''
    },
    QuotationRequestData: {
      Organization: '',
      PersonalContact: false,
      NewsLetter: false
    },
    Attachments: []
  }

  public items = []
  public itemsCount: number | null = 0
  public itemId: string | null = null

  @Mutation
  public setItems(items: any): void {
    this.items = items
  }

  @Mutation
  public setItemsCount(count: number): void {
    this.itemsCount = count
  }

  @Mutation
  public setItemId(id: string): void {
    this.itemId = id
  }

  @Mutation
  public updateCartData(cartData: ICartNL) {
    this.cartData = JSON.parse(JSON.stringify(cartData))

    localStorage.setItem(CART_DATA_KEY_NL, JSON.stringify(this.cartData))
  }

  @Mutation
  public updateCartDataBe(cartData: ICartBE) {
    this.cartDataBe = cartData

    localStorage.setItem(CART_DATA_KEY_BE, JSON.stringify(this.cartDataBe))
  }

  @Mutation
  public clearCartData() {
    this.cartData = {
      ProjectInformation: {
        Organization: '',
        ProjectName: '',
        ContactPersonName: '',
        PhoneNumber: '',
        EmailAddress: ''
      },
      QuotationRequestData: {
        Name: '',
        EmailAddress: '',
        PersonalContact: false
      },
      Attachments: []
    }

    this.cartDataBe = {
      ProjectInformation: {
        ProjectName: '',
        ProjectInfo: '',
        ContactPersonName: '',
        PhoneNumber: '',
        EmailAddress: ''
      },
      QuotationRequestData: {
        Organization: '',
        PersonalContact: false,
        NewsLetter: false
      },
      Attachments: []
    }

    localStorage.removeItem(CART_DATA_KEY_NL)
    localStorage.removeItem(CART_DATA_KEY_BE)
  }

  @Mutation
  getFromStorageNl(): void {
    const cartData = localStorage.getItem(CART_DATA_KEY_NL)
    if (cartData !== 'undefined' && cartData) {
      this.cartData = JSON.parse(cartData)
    }
  }

  @Mutation
  getFromStorageBe(): void {
    const cartData = localStorage.getItem(CART_DATA_KEY_BE)

    if (cartData !== 'undefined' && cartData) {
      this.cartDataBe = JSON.parse(cartData)
    }
  }

  @Action
  async getShoppingCartCount () {
    try {
      const result = await Axios.get(`${BASE_URL}/cart/itemscount`)
      if (result) {
        const resultsData: number = result.data
        this.context.commit('setItemsCount', resultsData)
      } else throw new Error()
    } catch (error) {
      console.error(error)
    }
  }
}
